var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 362.68 362.68"}},[_c('circle',{staticStyle:{"fill":"#005DE1"},attrs:{"cx":"85.8","cy":"181.34","r":"85.8"}}),_c('circle',{staticStyle:{"fill":"#FF007E"},attrs:{"cx":"276.88","cy":"181.34","r":"85.8"}})])}
var staticRenderFns = []

export { render, staticRenderFns }